export default function useScreen() {
  return useNuxtApp().$screen
}
